import { NonUndefined } from 'react-hook-form'
import { ButtonAddProps } from 'components/ButtonAdd/ButtonAdd'

export const BUTTON_ADD_ICON_SIZE: Record<NonUndefined<ButtonAddProps['size']>, string> = {
  'small': '16px',
  'medium': '18px',
}
